
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^2(40|98)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
